import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { FeatureTags } from '../../types/feature-tags';
import { ApiService } from './api.service';
import { Router } from '@angular/router';
import { NotificationService } from './notification.service';
import { SharedDataService } from './sharedata.service';
@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  private subject = new Subject<{}>();
  private behSubject = new BehaviorSubject<{}>({});
  private emitCloseDialogueSubject = new Subject<{}>();
  private cartWithoutRegistration: boolean = null;
  private featureTags:FeatureTags []= [];
  private cartProductsSubject = new Subject<string>();
  cartProducts = this.cartProductsSubject.asObservable();
  private userAddressInfo = new Subject<{}>();
  constructor(
    public apiService: ApiService,
    public router:Router, 
    public sharedDataService: SharedDataService,
  ) { 
  }
  subjectNext ( message: {}) {
    this.subject.next(message);
  }
  getSubject(): Observable<any> {
    return this.subject.asObservable();
  }

  behSubjectNext(message: {}) {
    this.behSubject.next(message);
  }

  getBehSubject() {
    return this.behSubject.asObservable();
  }

  getEmitCloseDialogueSubject(): Observable<any> {
    return this.emitCloseDialogueSubject.asObservable();
  }

  setEmitCloseDialogueSubjectNext(): void {
    this.emitCloseDialogueSubject.next(true);
  }

  getCartWithoutRegistrationStatus() {
    return this.cartWithoutRegistration;
  }

  setCartWithoutRegistrationStatus(data: any) {
    this.cartWithoutRegistration = data;
  }

  getFeatureTags(): FeatureTags[] {
    return this.featureTags;
  }

  setFeatureTags(featureTags: FeatureTags[]) {
    this.featureTags = featureTags;
  }

  updateSharedData(data: string) {
    this.cartProductsSubject.next(data);
  }
  
  getSharedData() {
    return this.cartProducts;
  }

  getUserAddressDetails(): Observable<{}> {
    return this.userAddressInfo.asObservable();
  }

  setUserAddressDetails(AddressInfo : {}): void {
    this.userAddressInfo.next(AddressInfo);
  }

  // public logout() {
  //   return new Promise((resolve, reject) => {
  //     this.apiService.logout().subscribe(
  //       data => {
  //         if (data['response']['status'] === 1) {
  //           localStorage.clear();
  //           sessionStorage.clear();
  //           this.apiService.setLogin({
  //             loggedIn: false,
  //             userDetails: null
  //           });
  //           this.subjectNext({ msg: 'logged out' });
  //           this.sharedDataService.cartDataSource.next(false)
            
            
  //           resolve(data); // Resolve the promise
  //         } else {
  //           this.notification.error(data['response']['message'], 5000);
  //           reject(data); // Reject the promise
  //         }
  //       },
  //       err => {
  //         console.log('get user details error', err);
  //         reject(err); // Reject the promise on error
  //       }
  //     );
  //   });
  // }
  

}
